import {BaseParameterFilterInputProps} from "./BaseParameterFilterInputProps";
import {ParameterDataType} from "../../types/Category";


/** BOOLEAN */
export interface ParameterFilterInputPropsBoolean
    extends BaseParameterFilterInputProps {
    dataType: ParameterDataType.BOOLEAN;
    value: "" | "true" | "false";
}


const ParameterFilterInputBoolean: React.FC<ParameterFilterInputPropsBoolean> =
    ({  name,
        value,
        onChange,
    }) =>
{
    const labelStyle: React.CSSProperties = { display: "flex", alignItems: "center", gap: "0.4rem" };
    return (
        <div style={{ display: "flex", flexDirection: "column", gap: "0.3rem" }}>
            <label style={labelStyle}>
                <input
                    type="radio"
                    checked={value === ""}
                    onChange={() => onChange(name, "")}
                />
                None
            </label>

            <label style={labelStyle}>
                <input
                    type="radio"
                    checked={value === "true"}
                    onChange={() => onChange(name, "true")}
                />
                True
            </label>

            <label style={labelStyle}>
                <input
                    type="radio"
                    checked={value === "false"}
                    onChange={() => onChange(name, "false")}
                />
                False
            </label>
        </div>
    );
};

export default ParameterFilterInputBoolean;


